document.addEventListener('DOMContentLoaded', function () {
  if (window.hljs && typeof hljs.highlightAll === 'function') {
    hljs.highlightAll();
  } else {
    document.addEventListener('readystatechange', function () {
      if (
        document.readyState === 'complete' &&
        window.hljs &&
        typeof hljs.highlightAll === 'function'
      ) {
        try {
          hljs.highlightAll();
        } catch (e) {
          if (
            typeof process !== 'undefined' &&
            process.env &&
            process.env.VERBOSE_TESTS
          ) {
            console.warn('[API Docs] highlightAll failed:', e);
          }
        }
      }
    });
  }

  const languageSelectors = document.querySelectorAll(
    'select[id^="language-selector"]'
  );

  languageSelectors.forEach((selector) => {
    selector.addEventListener('change', function () {
      const selectedLanguage = this.value;
      const selectorId = this.id;

      let codeExamples;
      if (selectorId === 'language-selector-wan') {
        codeExamples = document.querySelectorAll(
          '.code-example[data-selector="wan"]'
        );
      } else {
        codeExamples = document.querySelectorAll(
          '.code-example:not([data-selector])'
        );
      }

      codeExamples.forEach((example) => {
        example.style.display = 'none';
      });

      codeExamples.forEach((example) => {
        if (example.getAttribute('data-language') === selectedLanguage) {
          example.style.display = 'block';
        }
      });
    });
  });

  languageSelectors.forEach((selector) => {
    selector.value = 'python';
    selector.dispatchEvent(new Event('change'));
  });

  initApiTester();
});

function initApiTester() {
  const endpointSelect = document.getElementById('endpoint-select');
  const jsonInput = document.getElementById('json-input');
  const testButton = document.getElementById('test-api');
  const responseContainer = document.getElementById('response-container');
  const statusBadge = document.getElementById('status-badge');
  const responseTime = document.getElementById('response-time');
  const responseJson = document.getElementById('response-json');
  const responseLogs = document.getElementById('response-logs');
  const responseLogsContainer = document.getElementById('response-logs-container');
  const responseLogsFilter = document.getElementById('response-logs-filter');
  const responseLogsErrors = document.getElementById('response-logs-errors');
  const responseLogsDownload = document.getElementById('response-logs-download');

  const userApiKey = window.userApiKey || 'YOUR_API_KEY';

  function refreshLogDisplay(logState) {
    if (!responseLogs || !responseLogsContainer) return;
    if (!responseLogsContainer.style.display || responseLogsContainer.style.display === 'none') return;
    updateResponseLogs({ logs: [] }, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors);
  }

  const templates = {
    '/api/ra1': {
      api_key: userApiKey,
      prompt: 'A beautiful sunset over mountains',
      size: '1024x1024',
      enable_safety_checker: false,
    },
    '/api/wan': {
      api_key: userApiKey,
      image_url:
        'https://netwrckstatic.netwrck.com/static/uploads/aiartstation-art-aesthetic-character-elf-masculine-confident-engaging-wow-3.webp',
      prompt: 'The scene comes to life with gentle movement',
      num_frames: 81,
      resolution: '720p',
      response_mode: 'polling',
    },
    '/api/ltx-video-v097': {
      api_key: userApiKey,
      image_url:
        'https://netwrckstatic.netwrck.com/static/uploads/aiartstation-art-aesthetic-character-elf-masculine-confident-engaging-wow-3.webp',
      prompt: 'gentle zoom in revealing magical details',
    },
    '/api/ltx-2': {
      api_key: userApiKey,
      prompt: 'A calm cinematic dolly-in with subtle lighting shifts',
      image_url:
        'https://netwrckstatic.netwrck.com/static/uploads/aiartstation-art-aesthetic-character-elf-masculine-confident-engaging-wow-3.webp',
      duration: 6,
      resolution: '1080p',
      aspect_ratio: '16:9',
      fps: 25,
      generate_audio: true,
      mode: 'image-to-video',
      response_mode: 'polling',
    },
    '/api/ra2v': {
      api_key: userApiKey,
      image_url:
        'https://netwrckstatic.netwrck.com/static/uploads/aiartstation-art-aesthetic-character-elf-masculine-confident-engaging-wow-3.webp',
      prompt: 'epic action sequence with magical effects',
    },
    '/api/video-editor/render': {
      api_key: userApiKey,
      format: 'mp4',
      publish: false,
      project: {
        fps: 30,
        resolution: { width: 1920, height: 1080 },
        audio: { src: 'https://netwrckstatic.netwrck.com/static/uploads/sample-audio.mp3', gain: 1.0, fadeIn: 0.5, fadeOut: 0.5 },
        clips: [
          {
            src: 'https://netwrckstatic.netwrck.com/static/uploads/sample.mp4',
            type: 'video',
            duration: 4,
            audioGain: 0.8,
            audioGainEnd: 1.1,
            audioPan: -0.2,
            audioPanEnd: 0.2,
            audioGainKeyframes: [
              { time: 0, value: 0.8, ease: 'ease-in' },
              { time: 2, value: 1.1, ease: 'ease-out' },
            ],
            audioPanKeyframes: [
              { time: 0, value: -0.2 },
              { time: 2, value: 0.2 },
            ],
            audioMute: false,
            audioSolo: false,
            audioFadeIn: 0.2,
            audioFadeOut: 0.2,
          },
        ],
      },
    },
  };

  endpointSelect.addEventListener('change', function () {
    const endpoint = this.value;
    const template = templates[endpoint];
    if (template) {
      jsonInput.value = JSON.stringify(template, null, 2);
    }
  });

  if (endpointSelect && jsonInput) {
    const initialTemplate = templates[endpointSelect.value];
    if (initialTemplate) {
      jsonInput.value = JSON.stringify(initialTemplate, null, 2);
    }
  }

  testButton.addEventListener('click', async function () {
    const endpoint = endpointSelect.value;
    let requestData;
    const logState = { lines: [], lastCount: 0, filtered: [] };
    if (responseLogsFilter) responseLogsFilter.oninput = () => refreshLogDisplay(logState);
    if (responseLogsErrors) responseLogsErrors.onchange = () => refreshLogDisplay(logState);
    if (responseLogsDownload) {
      responseLogsDownload.onclick = () => {
        const lines = logState.filtered && logState.filtered.length ? logState.filtered : logState.lines;
        if (!lines || !lines.length) return;
        const blob = new Blob([lines.join('\n')], { type: 'text/plain' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = `netwrck-api-logs-${Date.now()}.txt`;
        link.click();
        URL.revokeObjectURL(url);
      };
    }

    try {
      requestData = JSON.parse(jsonInput.value);
    } catch (e) {
      alert('Invalid JSON: ' + e.message);
      return;
    }

    if (!requestData.api_key || requestData.api_key.trim() === '') {
      alert(
        'Please enter your API key. You can find it in your account settings.'
      );
      return;
    }

    testButton.disabled = true;
    testButton.textContent = 'Sending Request...';
    document.getElementById('response-placeholder').style.display = 'none';
    document.getElementById('response-content').style.display = 'block';
    document.getElementById('response-json').textContent = 'Sending request...';
    if (responseLogs) responseLogs.textContent = '';
    if (responseLogsContainer) responseLogsContainer.style.display = 'none';

    const startTime = Date.now();

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });

      const endTime = Date.now();
      const responseData = await response.json();

      statusBadge.textContent = response.ok
        ? `${response.status} Success`
        : `${response.status} Error`;
      statusBadge.className =
        'status-badge ' + (response.ok ? 'status-success' : 'status-error');
      responseTime.textContent = `${endTime - startTime}ms`;
      responseJson.textContent = JSON.stringify(responseData, null, 2);
      updateResponseLogs(responseData, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors);

      if (window.hljs && typeof hljs.highlightElement === 'function') {
        hljs.highlightElement(responseJson);
      }
      const apiKey = requestData.api_key;
      let statusUrl = '';
      if (responseData && typeof responseData.status_url === 'string') {
        statusUrl = responseData.status_url;
      } else if (responseData && responseData.result && typeof responseData.result.status_url === 'string') {
        statusUrl = responseData.result.status_url;
      } else if (responseData && responseData.job_id && responseData.status === 'in_progress') {
        if (endpoint === '/api/video-editor/render') {
          statusUrl = `/api/video-editor/render/status/${responseData.job_id}`;
        } else if (endpoint === '/api/ltx-2' || endpoint === '/api/fal') {
          statusUrl = `/api/fal/status/${responseData.job_id}`;
        }
      }
      if (statusUrl && apiKey) {
        statusUrl = appendApiKeyToStatusUrl(statusUrl, apiKey);
      }
      if (statusUrl) {
        pollJobStatus(statusUrl, statusBadge, responseJson, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors);
      }
    } catch (error) {
      const endTime = Date.now();

      statusBadge.textContent = 'Network Error';
      statusBadge.className = 'status-badge status-error';
      responseTime.textContent = `${endTime - startTime}ms`;
      responseJson.textContent = JSON.stringify(
        {
          error: 'Network error: ' + error.message,
          details: 'Check your connection and try again',
        },
        null,
        2
      );
      updateResponseLogs(null, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors);

      if (window.hljs && typeof hljs.highlightElement === 'function') {
        hljs.highlightElement(responseJson);
      }
    }

  testButton.disabled = false;
  testButton.textContent = 'Send Request';
  });
}

function appendApiKeyToStatusUrl(statusUrl, apiKey) {
  if (!apiKey || !statusUrl) return statusUrl;
  if (statusUrl.includes('api_key=')) return statusUrl;
  const separator = statusUrl.includes('?') ? '&' : '?';
  return `${statusUrl}${separator}api_key=${encodeURIComponent(apiKey)}`;
}

function pollJobStatus(statusUrl, statusBadge, responseJson, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors) {
  fetch(statusUrl)
    .then((resp) => resp.json())
    .then((data) => {
      if (data.status) {
        const progress = typeof data.progress === 'number' ? ` ${data.progress}%` : '';
        statusBadge.textContent =
          data.status === 'completed' ? '200 Success' : `${data.status}${progress}`;
        statusBadge.className =
          'status-badge ' + (data.status === 'failed' || data.status === 'cancelled' ? 'status-error' : 'status-success');
      }
      responseJson.textContent = JSON.stringify(data, null, 2);
      updateResponseLogs(data, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors);
      if (window.hljs && typeof hljs.highlightElement === 'function') {
        hljs.highlightElement(responseJson);
      }
      if (data.status === 'completed' || data.status === 'failed' || data.status === 'cancelled') {
        return;
      }
      setTimeout(() => pollJobStatus(statusUrl, statusBadge, responseJson, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors), 3000);
    })
    .catch(() => {
      setTimeout(() => pollJobStatus(statusUrl, statusBadge, responseJson, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors), 5000);
    });
}

function updateResponseLogs(data, responseLogs, responseLogsContainer, logState, responseLogsFilter, responseLogsErrors) {
  if (!responseLogs || !responseLogsContainer) return;
  const filterValue = responseLogsFilter ? responseLogsFilter.value.trim().toLowerCase() : '';
  const errorsOnly = responseLogsErrors ? responseLogsErrors.checked : false;
  if (!data) {
    responseLogs.textContent = '';
    responseLogsContainer.style.display = 'none';
    return;
  }
  const logs = extractLogs(data);
  if (!logs.length) {
    if (logState && logState.lines.length) {
      responseLogs.textContent = logState.lines.join('\n');
      responseLogsContainer.style.display = 'block';
      return;
    }
    responseLogs.textContent = '';
    responseLogsContainer.style.display = 'none';
    return;
  }
  if (logState) {
    if (logs.length < logState.lastCount) {
      logState.lines = [];
      logState.lastCount = 0;
    }
    if (logs.length > logState.lastCount) {
      const stamp = new Date().toLocaleTimeString();
      const newLines = logs.slice(logState.lastCount);
      newLines.forEach((line) => {
        logState.lines.push(`[${stamp}] ${line}`);
      });
      logState.lastCount = logs.length;
      if (logState.lines.length > 200) {
        logState.lines = logState.lines.slice(-200);
      }
    }
    if (logState.lines.length) {
      logState.filtered = filterLogLines(logState.lines, filterValue, errorsOnly);
      responseLogs.textContent = logState.filtered.join('\n');
      responseLogsContainer.style.display = 'block';
      return;
    }
  }
  responseLogs.textContent = filterLogLines(logs, filterValue, errorsOnly).join('\n');
  responseLogsContainer.style.display = 'block';
}

function filterLogLines(lines, filterValue, errorsOnly) {
  if (!lines || !lines.length) return [];
  return lines.filter((line) => {
    if (!line) return false;
    const lower = line.toLowerCase();
    if (errorsOnly && !/error|fail|exception/.test(lower)) return false;
    if (filterValue && !lower.includes(filterValue)) return false;
    return true;
  });
}

function extractLogs(data) {
  const candidates = [];
  if (data && data.logs) candidates.push(data.logs);
  if (data && data.result && data.result.logs) candidates.push(data.result.logs);
  if (data && data.log) candidates.push(data.log);
  if (data && data.result && data.result.log) candidates.push(data.result.log);
  for (const candidate of candidates) {
    if (!candidate) continue;
    if (Array.isArray(candidate)) {
      const lines = candidate
        .map((entry) => {
          if (!entry) return '';
          if (typeof entry === 'string') return entry;
          if (typeof entry.message === 'string') return entry.message;
          if (typeof entry.msg === 'string') return entry.msg;
          return '';
        })
        .filter((line) => line);
      if (lines.length) return lines;
    }
    if (typeof candidate === 'string') return [candidate];
    if (typeof candidate === 'object') {
      if (typeof candidate.message === 'string') return [candidate.message];
      if (typeof candidate.msg === 'string') return [candidate.msg];
    }
  }
  return [];
}
